export default __webpack_public_path__ + "static/media/selectPlotter1.a5c1a933.png";